import React from 'react'
import { ResponsiveContainer } from 'recharts'
import { Classes } from '@blueprintjs/core'
import { SubCardsWrapper, SubCard } from './CounterSubCard'

export default function LoadingState() {
  return (
    <>
      <ResponsiveContainer height={200} width="100%" className={Classes.SKELETON}>
        <div />
      </ResponsiveContainer>
      <SubCardsWrapper>
        <SubCard title="..." value="0" className={Classes.SKELETON} />
        <SubCard title="..." value="0" className={Classes.SKELETON} />
      </SubCardsWrapper>
    </>
  )
}
